const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#FFFCF9]" data-testid="terms-page">
      {/* Hero */}
      <section className="py-20 bg-spa-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="font-heading text-5xl md:text-6xl text-spa-neutral-800 mb-6">
              Terms & Conditions
            </h1>
            <p className="text-spa-neutral-500 text-lg">Last updated: January 2025</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl spa-shadow p-8 md:p-12">
            <div className="space-y-8">
              {[
                { title: "1. Booking & Appointments", content: "All appointments must be booked in advance through our website or WhatsApp. We recommend booking at least 24 hours in advance to secure your preferred time slot. A booking confirmation will be sent via WhatsApp. Please ensure you confirm your appointment to avoid cancellation." },
                { title: "2. Cancellation Policy", content: "We understand that plans can change. If you need to cancel or reschedule your appointment, please notify us at least 24 hours in advance. Late cancellations or no-shows may result in a cancellation fee or affect future booking privileges." },
                { title: "3. Arrival Time", content: "Please arrive 10-15 minutes before your scheduled appointment to complete any necessary paperwork and to allow yourself time to relax before your treatment. Late arrivals may result in shortened treatment time to accommodate other clients." },
                { title: "4. Health & Safety", content: "For your safety, please inform our staff of any medical conditions, allergies, or skin sensitivities before your treatment. Certain treatments may not be suitable for pregnant women or individuals with specific health conditions. Our therapists will advise you accordingly." },
                { title: "5. Payment", content: "Payment is due at the time of service. We accept cash and electronic transfers. Prices are subject to change without prior notice. Please confirm pricing when booking." },
                { title: "6. Medical Disclaimer", content: "Our spa services are intended for wellness and relaxation purposes. They are not intended to diagnose, treat, cure, or prevent any disease or medical condition. If you have any medical concerns, please consult with your healthcare provider before receiving any spa treatments." },
                { title: "7. Personal Belongings", content: "Kriel Colon and Beauty Spa is not responsible for lost, stolen, or damaged personal belongings. Please keep valuables secure during your visit." },
              ].map((section) => (
                <div key={section.title}>
                  <h2 className="font-heading text-2xl font-semibold text-spa-neutral-800 mb-4">{section.title}</h2>
                  <p className="text-spa-neutral-600 leading-relaxed">{section.content}</p>
                </div>
              ))}

              <div>
                <h2 className="font-heading text-2xl font-semibold text-spa-neutral-800 mb-4">8. Contact</h2>
                <p className="text-spa-neutral-600 leading-relaxed mb-4">If you have any questions about these terms, please contact us:</p>
                <ul className="text-spa-neutral-600 space-y-2">
                  <li>Phone: 065 902 9122</li>
                  <li>Email: krielcolonandbeautyspa@gmail.com</li>
                  <li>Address: 32 Kraanvoel Avenue, Kriel</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
